/**
 * @flow
 */

import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { Controller, useFormContext, useFieldArray } from 'react-hook-form';
import { injectIntl, defineMessages } from 'react-intl';
import { Form } from 'semantic-ui-react';

import { FormLabel } from '../../../../components';
import AdministratorSelect from '../../containers/cart/form/AdministratorSelect';
import CartItems from './form/CartItems';

import type { Intl } from '../../../../type';

const InvoicePaidGlobalStyle = createGlobalStyle`
    form.invoice-paid .ui.disabled {
        &.dropdown,
        &.input,
        &.input :disabled {
            opacity: 1;
        }
    }
`;

const intlMessages = defineMessages({
    administratorLabel: {
        id: 'pages.appointments.cart.form.administrator.label',
        defaultMessage: 'Seller',
    },
    administratorPlaceholder: {
        id: 'pages.appointments.cart.form.administrator.placeholder',
        defaultMessage: 'Select administrator',
    },
    cartItemsLabel: {
        id: 'pages.appointments.cart.form.cartItems',
        defaultMessage: 'Cart Items',
    },
});

type CartFormProps = {
    submitting: boolean,
    paid: boolean,
    intl: Intl,
};

function CartForm({ paid, intl }: CartFormProps) {
    const { control } = useFormContext();
    const { fields, append, remove } = useFieldArray({ control, name: 'items' });

    return (
        <Form className={paid ? 'invoice-paid' : ''}>
            <InvoicePaidGlobalStyle />
            <Controller
                name="administrator"
                control={control}
                render={({ field: { value, onChange } }) => (
                    <Form.Field>
                        <FormLabel>
                            {intl.formatMessage(intlMessages.administratorLabel)}
                        </FormLabel>
                        <AdministratorSelect
                            value={value}
                            onChange={(e, { value: v }) => onChange(v)}
                            disabled={paid}
                            placeholder={intl.formatMessage(
                                intlMessages.administratorPlaceholder,
                            )}
                            search
                            fluid
                        />
                    </Form.Field>
                )}
            />
            <FormLabel>
                {intl.formatMessage(intlMessages.cartItemsLabel)}
            </FormLabel>
            <CartItems
                fields={fields}
                paid={paid}
                append={append}
                remove={remove}
            />
        </Form>
    );
}

export default injectIntl(CartForm);
